import classNames from 'classnames';

import { setupForDark } from '@theme';

export default function CenteredDivider({ text }: { text: string }) {
  return (
    <div
      className={classNames('flex items-center gap-sm p-xs mb-sm', setupForDark('text-tertiary'))}
    >
      <div className={classNames('h-[1px] flex-grow', setupForDark('bg-label-primary'))}></div>
      <div className='P2M'>{text}</div>
      <div className={classNames('h-[1px] flex-grow', setupForDark('bg-label-primary'))}></div>
    </div>
  );
}
